module.exports = __webpack_public_path__ + "img/no_result_image.dee30be1.png";